<template>
    <div>
        <ul class="list-reset">
            <li class="border-b" v-for="item in series" :key="item.originalCode">
                <div
                        @click="seriesToggle(item)"
                        class="hover:bg-blue-lighter pl-4 pr-4 pt-6 pb-4 text-black flex justify-between cursor-pointer"
                        :class="{'bg-blue-lightest': isSelected(item)}"
                >
                    <div class="text-blue-dark">
                        <i class="fa fa-fw"
                           :class="{'fa-check-square': isSelected(item), 'fa-square-o': !isSelected(item)}"
                        ></i>
                    </div>
                    <div class="flex-1 flex xl:flex-row flex-col-reverse">
                        <div class="flex-1 pl-4 pt-4 xl:pt-0">
                            {{ item.description }}
                            <div class="mt-4 text-grey-dark hidden xl:block">
                                {{ item.begin.substring(0,4) }} - {{ item.end.substring(0,4) }}
                            </div>
                        </div>
                        <div class="flex">
                            <div class="w-full pl-4">
                                <p class="text-xs text-grey-dark uppercase tracking-wide text-right">
                                    {{ item.end.substring(0,4) }}
                                </p>
                                <p class="text-black text-xl text-right">
                                    {{ item.latest | number_format }}
                                </p>
                                <p class="text-grey-dark tracking-wide text-right">
                                    {{ item.unit }}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "LibraryCustom",

        inject: ['report'],

        data:() => ({
            loading: false,
            series: [],
        }),

        mounted() {
            this.loading = true;
            let that = this;
            http.get('/series_custom').then(function (result) {
                that.loading = false;
                that.series = result.data.series;
            })
        },

        filters: {
            number_format: function (number) {
                return new Intl.NumberFormat('en-GB').format(number);
            },
        },

        methods: {
            isSelected(series) {
                return this.report.selected.findIndex(function (item) {
                    return item.originalCode === series.originalCode;
                }) !== -1;
            },
            seriesToggle: function (series) {
                // check if already in list
                if (!this.isSelected(series)) {
                    this.report.selected.push(series);
                    return;
                }

                this.report.selected = this.report.selected.filter(function (item) {
                    return item.originalCode !== series.originalCode;
                });
            },
        }
    }
</script>

<style scoped>

</style>
